import axios from 'axios';

export default {
  async getSiteBillingProposal(siteId, dates) {
    return axios({
      url: `/api/tenant/billing-proposal/site/${siteId}`,
      params: {
        dates: (dates || []).join(',') || undefined,
      },
    }).then(r => r.data);
  },
  async getSiteBillingProposalXlsx(siteId, dates) {
    return axios({
      url: `/api/tenant/billing-proposal/site/${siteId}/xlsx`,
      params: {
        dates: (dates || []).join(',') || undefined,
      },
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'blob',
    }).then(r => r.data);
  },
};
